import React from 'react'
import { browserHistory, Link } from 'react-router'
import { Card, CardActions, CardHeader, CardText, CardTitle } from 'material-ui/Card'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import ListIcon from 'material-ui/svg-icons/action/list'
import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import Dialog from 'material-ui/Dialog'
import _, { find, remove } from 'lodash'
import moment from 'moment'
import qs from 'qs'

import api from '../../../../api'
import { statusName } from '../../../../fieldOptions/waitlistStatuses'
import { formatCurrency, formatDateTime } from '../../../../formatters'
import OfferSession from './offer'
import CreateReservation from './create-reservation'

const styles = {
  cardActions: {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
    padding: '14px 0',
    marginRight: -8
  }
}

const Spacer = () => <div style={{ paddingTop: '20px' }} />

export default class ShowSessionWaitlister extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      loaded: false,
      selectedPayments: [],
      showRefundDialog: false,
      newOffer: {},
      newReservation: {}
    }
  }

  componentWillMount () {
    this.loadWaitlister()
      .then(waitlister => Promise.all([
        this.loadReservation(waitlister),
        this.loadUser(waitlister),
        this.loadPayments(waitlister),
        this.loadSessionSales(waitlister)
      ]))
      .then(() => {
        this.setState({ loaded: true })
      })
  }

  loadWaitlister () {
    return api.get(`admin/session_waitlisters/${this.props.params.waitlisterId}`)
      .then(res => res.json())
      .then(waitlister => {
        this.setState({ waitlister })
        return waitlister
      })
  }

  loadUser (waitlister) {
    return api.get(`admin/users/${waitlister.user_id}`)
      .then(res => res.json())
      .then(user => {
        this.setState({ user })
      })
  }

  loadReservation (waitlister) {
    const { user_id: userId, session_sale_id: sessionSaleId } = waitlister

    const body = {
      'filters[user_id]': userId,
      'filters[session_sale_id]': sessionSaleId
    }

    return api.get('admin/session_reservations', { body })
      .then(res => res.json())
      .then(reservations => {
        if (reservations.length) {
          this.setState({ reservation: reservations[0] })
        } else {
          this.setState({ reservation: null })
        }
      })
  }

  loadPayments (waitlister) {
    const { order_item_id: orderItemId } = waitlister

    return api.get(`admin/order_items/${orderItemId}`)
      .then(res => res.json())
      .then(orderItem => {
        const body = {
          filters: {
            order_id: orderItem.order_id
          }
        }
        return api.get('admin/payments', { body })
          .then(res => res.json())
          .then(payments => {
            this.setState({ payments })
            return payments
          })
      })
  }

  loadSessionSales (waitlister) {
    return api.get('admin/session_sales')
      .then(res => res.json())
      .then(sessionSales => {
        const now = moment()
        const [waitlisterSession] = remove(sessionSales, { id: waitlister.session_sale_id })
        const currentSessions = _(sessionSales)
          .filter(sessionSale => moment(sessionSale.advertised_end_date).isAfter(now))
          .sortBy('advertised_start_date')
          .value()

        if (waitlisterSession) {
          currentSessions.unshift({ ...waitlisterSession, title: `${waitlisterSession.title} (current)` })
        }

        this.setState({ sessionSales: currentSessions })

        return currentSessions
      })
  }

  handleOfferUpdated = newOffer => {
    this.setState({ newOffer })
  }

  handleOfferSubmit = () => {
    const { waitlister, newOffer } = this.state
    const path = `admin/session_waitlisters/${waitlister.id}/offer_session`
    const body = newOffer

    api.post(path, { body })
      .then(res => res.json())
      .then(waitlister => {
        this.setState({ waitlister })
      })
  }

  handleReservationUpdated = newReservation => {
    this.setState({ newReservation })
  }

  handleReservationSubmit = event => {
    const { waitlister, newReservation } = this.state
    const body = newReservation

    return api.post(`admin/session_waitlisters/${waitlister.id}/reservations`, { body })
      .then(res => res.json())
      .then(waitlister => {
        this.setState({ waitlister })
      })
  }

  handlePaymentSelection = selection => {
    const { payments } = this.state
    let selectedPayments

    switch (selection) {
      case 'all':
        selectedPayments = payments.map(payment => payment.id)
        break
      case 'none':
        selectedPayments = []
        break
      default:
        selectedPayments = selection.map(selectedIndex => payments[selectedIndex].id)
        break
    }

    this.setState({ selectedPayments })
  }

  handleRefundSubmit = event => {
    const { selectedPayments, payments, waitlister, newAmountPaid } = this.state

    const createRefunds = selectedPayments.map(id => {
      const payment = find(payments, { id })
      return api.post('admin/refunds', {
        body: {
          payment_id: payment.id,
          reference_number: payment.reference_number,
          amount: payment.amount,
          reason: 'Refund session waitlist fee'
        }
      })
    })

    Promise.all(createRefunds)
      .then(() => {
        return api.patch(`admin/session_waitlisters/${waitlister.id}`, {
          body: {
            refunded_at: new Date(),
            amount_paid: parseFloat(newAmountPaid)
          }
        })
      })
      .then(res => res.json())
      .then(waitlister => {
        this.setState({
          showRefundDialog: false,
          newAmountPaid: '',
          waitlister
        })
      })
  }

  handleRemoveFromWaitlist = () => {
    const { waitlister } = this.state

    return api.patch(`admin/session_waitlisters/${waitlister.id}`, {
      body: { status: 'declined' }
    }).then(waitlister => {
      this.setState({ waitlister })
      browserHistory.push(this.listPath({ status: 'declined' }))
    })
  }

  openRefundDialog = () => {
    this.setState(prevState => {
      const sumRefunds = prevState.selectedPayments.reduce((sum, id) => {
        return sum + find(prevState.payments, { id }).amount
      }, 0)

      return {
        ...prevState,
        showRefundDialog: true,
        newAmountPaid: prevState.waitlister.amount_paid - sumRefunds
      }
    })
  }

  closeRefundDialog = () => {
    this.setState({ showRefundDialog: false })
  }

  handleAmountPaidChange = (e, value) => {
    this.setState({ newAmountPaid: value })
  }

  listPath (filters = {}) {
    return `/events/session-sales/${this.props.params.sessionSaleId}/waitlist?${qs.stringify({ filters })}`
  }

  render () {
    if (!this.state.loaded) {
      return null
    }

    const {
      payments,
      reservation,
      selectedPayments,
      sessionSales,
      user,
      waitlister,
      newReservation,
      newOffer
    } = this.state

    const showActions = !reservation && waitlister.status === 'hold'

    return (
      <div>
        <CardActions style={styles.cardActions}>
          <FlatButton
            onClick={() => {
              browserHistory.push(this.listPath())
            }}
            icon={<ListIcon />}
            title='Back to list'
          />
        </CardActions>

        <CardTitle title={`Session Sale Waitlist #${waitlister.id}`} style={{ paddingLeft: 0 }} />

        <Card>
          <CardHeader title='Waitlist Details' />
          <Table selectable={false}>
            <TableBody displayRowCheckbox={false}>
              <TableRow>
                <TableRowColumn>
                  User
                </TableRowColumn>
                <TableRowColumn>
                  <Link to={`/security/users/${user.id}/edit`}>
                    {user.name}
                  </Link>
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>
                  Status
                </TableRowColumn>
                <TableRowColumn>
                  {statusName(waitlister.status)}
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>
                  Amount Paid
                </TableRowColumn>
                <TableRowColumn>
                  {formatCurrency(waitlister.amount_paid)}
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>
                  Order
                </TableRowColumn>
                <TableRowColumn>
                  <Link to={`/ecommerce/orders/${waitlister.order_id}/edit`}>
                    {waitlister.order_id}
                  </Link>
                </TableRowColumn>
              </TableRow>
              {
                waitlister.refunded_at &&
                  <TableRow>
                    <TableRowColumn>
                    Refunded
                    </TableRowColumn>
                    <TableRowColumn>
                      {formatDateTime(waitlister.refunded_at)}
                    </TableRowColumn>
                  </TableRow>
              }
            </TableBody>
          </Table>
        </Card>

        <Spacer />

        {
          showActions &&
            <OfferSession
              offer={newOffer}
              sessionSales={sessionSales}
              onChange={this.handleOfferUpdated}
              onSubmit={this.handleOfferSubmit}
            />
        }

        <Spacer />

        {
          showActions &&
            <CreateReservation
              reservation={newReservation}
              sessionSales={sessionSales}
              onChange={this.handleReservationUpdated}
              onSubmit={this.handleReservationSubmit}
            />
        }

        <Spacer />

        {
          showActions &&
            <Card>
              <CardHeader title='Refund Waitlist Payment' />
              <CardText>
                <Table multiSelectable onRowSelection={this.handlePaymentSelection}>
                  <TableHeader>
                    <TableRow>
                      <TableHeaderColumn>ID</TableHeaderColumn>
                      <TableHeaderColumn>Amount</TableHeaderColumn>
                      <TableHeaderColumn>Date</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {payments.map(payment => (
                      <TableRow key={payment.id}>
                        <TableRowColumn>{payment.id}</TableRowColumn>
                        <TableRowColumn>{formatCurrency(payment.amount)}</TableRowColumn>
                        <TableRowColumn>{formatDateTime(payment.created_at)}</TableRowColumn>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CardText>
              <CardActions>
                <RaisedButton
                  label='Refund'
                  primary
                  onClick={this.openRefundDialog}
                  disabled={selectedPayments.length === 0}
                />

                <Dialog
                  modal
                  open={this.state.showRefundDialog}
                  title='Confirm Refund'
                  actions={[
                    <FlatButton
                      label='Cancel'
                      primary
                      onClick={this.closeRefundDialog}
                    />,
                    <FlatButton
                      label='Submit'
                      primary
                      onClick={this.handleRefundSubmit}
                      disabled={Number.isNaN(parseFloat(this.state.newAmountPaid))}
                    />
                  ]}
                >
                  <p>Refunding payments will decrease the credit to use towards a future reservation.</p>
                  <p>Confirm the new credit amount and click "Submit" to process the refund.</p>
                  <TextField
                    floatingLabelText='New Waitlist Credit'
                    value={this.state.newAmountPaid}
                    onChange={this.handleAmountPaidChange}
                  />
                </Dialog>
              </CardActions>
            </Card>
        }

        <Spacer />

        {
          showActions &&
            <Card>
              <CardHeader title='Remove From Waitlist' />
              <CardText>
                <p>Marks the this user's waitlist status as "declined".</p>

              </CardText>
              <CardActions>
                <RaisedButton
                  label='Remove From Waitlist'
                  primary
                  onClick={this.handleRemoveFromWaitlist}
                />
              </CardActions>
            </Card>
        }
      </div>
    )
  }
}

// @ts-ignore
ShowSessionWaitlister.propTypes = {
  params: React.PropTypes.shape({
    sessionSaleId: React.PropTypes.string.isRequired,
    waitlisterId: React.PropTypes.string.isRequired
  }).isRequired
}
